import actionsTypes from "../constants/ActionTypes";

const initialState = {
  currentCompany: null,
  companies: [],
  isAdmin: false,
  isOperator: false,
};

export const CompanyReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionsTypes.SET_CURRENT_COMPANY:
      return {
        ...state,
        currentCompany: action.company,
      };
    case actionsTypes.SET_COMPANIES:
      return {
        ...state,
        companies: action.companies,
      };
    case actionsTypes.SET_USER_ROLES:
      return {
        ...state,
        isAdmin: action.isAdmin,
        isOperator: action.isOperator,
      };
    default:
      return state;
  }
};


